<template>
  <!-- //完成 -->
  <div class="result">
    <van-nav-bar
      title="成绩查询"
      left-arrow
      @click-left="$router.go(-1)"
      placeholder
      fixed
      safe-area-inset-top
    />
    <van-cell-group>
      <van-cell
        title="准考证号"
        :value="info.written_pass_number || '暂无数据'"
      />
      <van-cell title="身份证号" :value="info.id_card || '暂无数据'" />
      <van-cell title="姓名" :value="info.name || '暂无数据'" />

      <van-cell title="岗位编号" :value="info.position_no || '暂无数据'" />
      <van-cell title="报考岗位" :value="info.position_applied || '暂无数据'" />
      <van-cell
        title="笔试成绩"
        :value="Number(info.written_exam_score || 0).toFixed(2)"
      />
      <van-cell
        title="岗位笔试排名"
        :value="info.written_ranking || '暂无数据'"
      />
      <van-cell
        title="是否进入资格复审"
        :value="status2[info.written_exam_pass || 0]"
      />

      <van-cell
        title="面试成绩"
        :value="Number(info.interview_exam_score || 0).toFixed(2)"
      />
      <van-cell
        title="面试排名"
        :value="info.interview_ranking || '暂无数据'"
      />
      <van-cell
        title="面试结果"
        :value="status[info.interview_exam_pass || 0]"
      />
      <van-cell
        title="综合成绩"
        :value="Number(info.ac_exam_score || 0).toFixed(2)"
        :border="false"
      />
      <van-cell title="综合成绩排名" :value="info.ac_ranking || '暂无数据'" />
      <van-cell
        title="是否录用"
        :value="
          info.offer == 0 ? '未审核' : info.offer == 1 ? '录用' : '未录用'
        "
        :border="false"
      />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      numTotal: 0,
      status: {
        0: "未审核",
        1: "已通过",
        2: "未通过",
      },
      status2: {
        0: "未审核",
        1: "是",
        2: "否",
      },
    };
  },
  methods: {
    getDetail() {
      this.$api.getDz
        .getUserFormDetail({ city: this.$store.state.cityId })
        .then((res) => {
          try {
            if (Object.keys(res.result).length) {
              this.info = { ...res.result };
              this.numTotal =
                this.info.written_exam_score * 0.4 +
                this.info.ac_exam_score * 0.6;
            }
          } catch (error) {
            console.log(error);
          }
        });
    },
    isIn(key) {
      this.$api.getDz.enroll_entrance().then((res) => {
        if (res.code == 200) {
          let entrance = res.result || [];
          if (entrance[key] && entrance[key] != false) {
          } else {
            this.$store.commit("setRedirect", "");
            this.$router.push({ path: "/home" });
          }
        }
      });
    },
  },
  created() {
    this.isIn("资格审核及成绩查询入口");
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.result {
  height: 100vh;
  padding: 15px;
  text-align: left;
}
</style>
